import ManageAppointments from './ManageAppointments';

export default ManageAppointments;
